<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  import ExtraButton from '../../common/components/ExtraButton.svelte';

  export let label: string;
  export let type = 'secondary';
  export let variant = 'solid';
  export let disabled = false;
  export let productCode = '';
  export let size = 'medium';
  export let width = '100%';
  const dispatcher = createEventDispatcher();

  function onButtonClick() {
    dispatcher('click', null);
  }

  let productBtnAttrs = {
    'data-product-id': productCode,
  };
</script>

<div class="button-div">
  <ExtraButton
    {variant}
    color={type}
    {size}
    {disabled}
    style="min-width : {width} !important"
    dataAttrs={productBtnAttrs}
    on:click={() => onButtonClick()}
  >
    {label}
  </ExtraButton>
</div>

<style lang="scss">
  @import '../../common/styles/colors.new.scss';

  .button-div :global {
    .mdc-button {
      border-radius: 100px !important;
      min-height: 48px !important;
      width: 100%;
      &:disabled {
        background-color: $secondary-gray-02;
        color: $secondary-gray-01;
      }
      @include desktop-min-width {
        border-radius: 100px;
        padding: 18px 36px;
        min-height: 64px !important;
        width: 100%;
      }
      .mdc-button__ripple {
        border-radius: 100px !important;
      }
      .mdc-button__label {
        font-weight: 700;
        font-size: 14px;
        line-height: 18px;
        @include desktop-min-width {
          font-size: 24px;
          line-height: 28px;
          width: 100%;
        }
      }
    }
  }
</style>
